module.exports = __webpack_public_path__ + "img/20210730_121229.19e96ffa.jpg";